import React from 'react'
import './App.scss'
import ErrorBoundary from './ErrorBoundary'
import { ImageEditorWrapper } from './imageEditorComponent/index'

function App() {
  return (
    <ErrorBoundary>
      <ImageEditorWrapper />
    </ErrorBoundary>
  )
}

export default App